import { render, staticRenderFns } from "./GuidelineRow.vue?vue&type=template&id=96ef24ba&scoped=true&"
import script from "./GuidelineRow.vue?vue&type=script&lang=ts&"
export * from "./GuidelineRow.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineRow.vue?vue&type=style&index=0&id=96ef24ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ef24ba",
  null
  
)

export default component.exports